export default __webpack_public_path__ + "static/media/skateboard_dark.e9bf7b96.png";